import { Routes } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { ErrorComponent } from './error';
import { FileMatcherService } from './core/services';
import { StatsComponent } from './stats';
// import { TestComponent } from './test/test.component';

export const appRoutes: Routes = [
  {
    path: '',
    component: WelcomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'stats',
    component: StatsComponent
  },
  // {
  //   path: 'test',
  //   component: TestComponent
  // },
  {
    path: 'settings',
    loadChildren: () => import('./edit/edit.routes').then(m => m.staticEditRoutes),
  },
  {
    path: '**',
    canActivate: [FileMatcherService],
    loadChildren: () => import('./edit/edit.routes').then(m => m.editRoutes)
  },
  {
    path: '**',
    component: ErrorComponent
  },
];
